module.exports = __webpack_public_path__ + "media/yamete_kudasai.5e9dd5eb.mp3";